import { ApiRequest } from '@zeal/zeal-lib';
import { ENDPOINTS } from '../endpoints';

export async function listGifts({ queryKey: [, filters] }: any) {
	return new ApiRequest(ENDPOINTS.giftFriend.gifts.list)
		.addHeader('Accept', 'application/json')
		.addQuery('paginate', filters?.paginate)
		.addQuery('page', filters?.page)
		.GET<ApiResponseWithPagination<any>>()
		.then((payload) => ({
			data: payload?.data,
			totalCount: payload?.meta?.total,
			pageNum: payload?.meta?.current_page,
			pagesCount: payload?.meta?.last_page,
		}));
}
export async function createGift({ payload }: any) {
	return new ApiRequest(ENDPOINTS.giftFriend.gifts.create)
		.addHeader('Accept', 'application/json')
		.POST(payload);
}
export async function updateGift({
	payload,
	giftId,
}: {
	payload: any;
	giftId: string;
}) {
	payload?.append('_method', 'PUT');

	return new ApiRequest(ENDPOINTS.giftFriend.gifts.update(giftId))
		.addHeader('Accept', 'application/json')
		.POST(payload);
}
export async function deleteGift(giftId: any) {
	return new ApiRequest(ENDPOINTS.giftFriend.gifts.delete(giftId))
		.addHeader('Accept', 'application/json')
		.DELETE();
}
export async function giftFriendCategories() {
	return new ApiRequest(ENDPOINTS.giftFriend.gifts.categories)
		.addHeader('Accept', 'application/json')
		.GET();
}
